/**
 * Created by Jew on 4/27/2018.
 */
import { Component, Inject, OnInit} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';

@Component({
   selector: 'app-corporate-permission',
   templateUrl: './permission.component.html',
   styleUrls: ['./permission.component.css']
})
export class CorporatePermissionComponent implements OnInit {
   user: any;
   array = ['ALL', 'CUSTOM'];
   status = 'ALL';
   email_value: string;
   searchFocused: boolean;
   searchResult: any[];
   private timer: any;
   listMember = [];
   item: any;
   role = 'View';

   constructor(@Inject(MAT_DIALOG_DATA) private data: any,
               public service: IdexService, private dialogRef: MatDialogRef<CorporatePermissionComponent>) {
      this.user = this.service.user;
   }
   ngOnInit() {
      this.getPermission();
   }

   getPermission() {
      this.service.get('/permission/' + this.data.item.id)
         .subscribe(
            data => {
               this.status = data.isInherited ? 'ALL' : 'CUSTOM';
               this.listMember = data.authorities;
               for (let i = 0; i < this.listMember.length; i++) {
                 this.listMember[i].oldValue = this.listMember[i].role;
               }
            }, error =>
               this.dialogRef.close()
         );
   }

   selectSearchItem(item: any) {
      setTimeout(() => {
         this.searchFocused = false;
      }, 100);
      this.email_value = item.id;
      this.item = item;
   }

   onSearchChange(input: any) {
      this.searchResult = null;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const q = input.value.trim();
      if (q.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.service.get('/work/' + this.data.data.tin + '/members?filter=' + encodeURIComponent(input.value))
            .subscribe(
               data => {
                  if (this.timer == null) {
                     data.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : ((b.name.toUpperCase() > a.name.toUpperCase()) ? -1 : 0));
                     this.searchResult = data;
                  }
               }, error =>
                  this.dialogRef.close()
            );
      }, 300);
   }
   onSearchFocus() {
      this.searchFocused = true;
   }
   onSearchBlur() {
      setTimeout(() => {
         this.searchFocused = false;
      }, 300);
   }

   roleChange(item: any) {
      const list = [];
      list.push(item);
      const obj = {id: item.id, name: item.name, role: item.oldValue, remove: true};
      list.push(obj);

      const body = {isInherited: this.status === 'ALL' ? true : false, authorities: list};
      this.service.post('/permission/' + this.data.item.id, body)
         .subscribe(
            data => {
              item.oldValue = item.role;
            }, error =>
               this.dialogRef.close()
         );
   }

   save(status) {
      for (let i = 0; i < this.listMember.length; i++) {
         this.listMember[i].remove = true;
      }
      const body = {isInherited: status === 'ALL' ? true : false, authorities: this.listMember};
      this.service.post('/permission/' + this.data.item.id, body)
         .subscribe(
            data => {
               this.listMember = [];
            });
   }

   addMember(input: any) {
      if (input.value.length === 0) {
         input.focus();
      } else {
         if (this.checkDuplicate(input.value)) {
            this.data.data.translate.get('alert.duplicate_username').subscribe(s => { this.data.data.toast.error(s); });
         } else if (this.checkValidUser(input.value)) {
            const list = [];
            this.item.role = this.role;
            list.push(this.item);
            const body = {isInherited: this.status === 'ALL' ? true : false, authorities: list};
            this.service.post('/permission/' + this.data.item.id, body)
               .subscribe(
                  data => {
                     this.item.oldValue = this.item.role;
                     this.listMember.push(this.item);
                  }, error =>
                     this.dialogRef.close()
               );
            input.value = '';
         } else {
            this.data.data.translate.get('alert.invalid_username_only').subscribe(s => { this.data.data.toast.error(s); });
         }
      }
   }

   deleteMember(item: any) {
      const list = [];
      item.remove = true;
      list.push(item);
      const body = {isInherited: this.status === 'ALL' ? true : false, authorities: list};
      this.service.post('/permission/' + this.data.item.id, body)
         .subscribe(
            data => {
               const i = this.listMember.indexOf(item);
               if (i !== -1) { this.listMember.splice(i, 1); }
            }, error =>
               this.dialogRef.close()
         );
   }

   checkValidUser(input: string) {
      for (let i = 0; i < this.searchResult.length; i++) {
         if (this.searchResult[i].id === input) {
            this.item = this.searchResult[i];
            return true;
         }
      }
   }
   checkDuplicate(input: string) {
      for (let i = 0; i < this.listMember.length; i++) {
         if (this.listMember[i].id === input) {
            return true;
         }
      }
   }
}
